/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type CreateOutlookVerificationKeyInput = {
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type CreateOutlookVerificationKeyMutationVariables = {
    input: CreateOutlookVerificationKeyInput;
};
export type CreateOutlookVerificationKeyMutationResponse = {
    readonly createOutlookVerificationKey: {
        readonly key: string | null;
    } | null;
};
export type CreateOutlookVerificationKeyMutation = {
    readonly response: CreateOutlookVerificationKeyMutationResponse;
    readonly variables: CreateOutlookVerificationKeyMutationVariables;
};



/*
mutation CreateOutlookVerificationKeyMutation(
  $input: CreateOutlookVerificationKeyInput!
) {
  createOutlookVerificationKey(input: $input) {
    key
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateOutlookVerificationKeyInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateOutlookVerificationKeyPayload",
    "kind": "LinkedField",
    "name": "createOutlookVerificationKey",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "key",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateOutlookVerificationKeyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateOutlookVerificationKeyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "CreateOutlookVerificationKeyMutation",
    "operationKind": "mutation",
    "text": "mutation CreateOutlookVerificationKeyMutation(\n  $input: CreateOutlookVerificationKeyInput!\n) {\n  createOutlookVerificationKey(input: $input) {\n    key\n  }\n}\n"
  }
};
})();
(node as any).hash = '1a9af3ad49bea7c856cad2a22ee1e136';
export default node;
